import { createSlice } from '@reduxjs/toolkit';
import { RESET_ALL_REDUCERS } from 'actions';

const initialState = {
    twoFaSession: null,
};

const preIdentitySlice = createSlice({
    name: 'preIdentity',
    initialState,
    reducers: {
        setTwoFaSession: (state, action) => {
            state.twoFaSession = action.payload ?? null;
        },

        clearTwoFaSession: (state) => {
            state.twoFaSession = null;
        },

        decrementOtpAttempt: (state, action) => {
            const { otpType } = action.payload ?? {};
            if (!otpType) return;
            const left = state.leftOtpAttempts?.[otpType];
            if (typeof left !== 'number') return;
            state.leftOtpAttempts[otpType] = left - 1;
        },
    },
    extraReducers: (builder) => {
        // App-wide reset on session teardown (new token / re-auth).
        builder.addCase(RESET_ALL_REDUCERS, () => initialState);
    },
});

export const { setTwoFaSession, clearTwoFaSession, decrementOtpAttempt } = preIdentitySlice.actions;

export default preIdentitySlice.reducer;
